import { render } from "./MobileProject.vue?vue&type=template&id=10fea92a"
import script from "./MobileProject.vue?vue&type=script&lang=js"
export * from "./MobileProject.vue?vue&type=script&lang=js"

import "./MobileProject.vue?vue&type=style&index=0&id=10fea92a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__